/**
 * Benchmark Fee is shown with two decimals everywhere (LR-599): the Inventory
 * tab, the Availability table cell and clipboard copies must not disagree
 * with each other or with the CSV export. Both render and copy paths share
 * this formatter so they cannot drift apart again.
 */
export const formatBenchmarkFee = (value: number): string => `${value.toFixed(2)}%`;
